<div matDialogTitle class="roadside-assistance__header">
  <h1 class="roadside-assistance__header__title" i18n="@@S_RSA_TILE">Roadside Assistance</h1>
  <button mat-icon-button matDialogClose class="roadside-assistance__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="roadside-assistance__content">
  <div class="warning-box" *ngIf="(hasVin$ | async) === false">
    <mat-icon class="warning-box__icon mat-icon-size-sm" svgIcon="ds-ic-important"></mat-icon>
    <div class="warning-box_text">
      <span i18n="@@S_RSA_MODAL_NOT_COVERED" id="rsa-modal-not-covered"
        >This vehicle is not covered by Roadside Assistance because the VIN is not registered.</span
      >
      <a
        *ngIf="hasFullManageVehiclesPermission$ | async"
        id="rsa-link"
        href="{{ roadsideAssistanceMicrositeUrl }}"
        i18n="@@S_RSA_MODAL_REGISTER_VIN"
        >Register the VIN and activate Roadside Assistance.</a
      >
      <span *ngIf="(hasFullManageVehiclesPermission$ | async) === false" i18n="@@S_RSA_MODAL_CONTACT_ADMIN"
        >Contact your admin to register the VIN and activate Roadside Assistance.</span
      >
    </div>
  </div>

  <div class="rsa-content rsa-content-text">
    <span class="rsa-content-item" i18n="@@S_SEND_RSA_WHEN_NEEDED">When Roadside Assistance is needed:</span>
    <div class="rsa-content-item">
      <span class="rsa-content-item__circle-number">1</span>
      <div class="rsa-content-item__text-container">
        <span i18n="@@S_PHONE" class="rsa-content-item__text-first-row">Phone</span>
        <span class="rsa-content-item__text-second-row rsa-content-item__phone-number">1-833-433-8841</span>
      </div>
    </div>
    <div class="rsa-content-item" *ngIf="hasVin$ | async">
      <span class="rsa-content-item__circle-number">2</span>
      <div class="rsa-content-item__text-container">
        <span i18n="@@S_SEND_RSA_PROVIDE_VIN" class="rsa-content-item__text-first-row">Provide the 8 last characters of the VIN</span>
        <fm-vehicle-identification-number
          [vin]="vin$ | async"
          *ngIf="hasVin$ | async"
          class="rsa-content-item__text-second-row"
        ></fm-vehicle-identification-number>
      </div>
    </div>
    <div class="rsa-content-item">
      <span class="rsa-content-item__circle-number" *ngIf="hasVin$ | async">3</span>
      <span class="rsa-content-item__text-container" i18n="@@S_SEND_RSA_PROVIDE_LOCATION" class="rsa-content-item__text-first-row"
        >Provide the vehicle’s location</span
      >
    </div>
    <div class="rsa-content-item">
      <span class="rsa-content-item__circle-number" *ngIf="hasVin$ | async">4</span>
      <span class="rsa-content-item__text-container" i18n="@@S_SEND_RSA_SEND_HELP" class="rsa-content-item__text-first-row"
        >We’ll send help to your vehicle!</span
      >
    </div>
  </div>
</div>

<div matDialogActions class="roadside-assistance__actions">
  <button
    mat-flat-button
    matDialogClose
    color="accent"
    id="btn-rsa-close"
    a7s-id="live-map-map-rsa-modal-close-button"
    i18n="@@S_CLOSE"
    class="roadside-assistance__actions__buttons__save btn-uppercase vzc-small"
  >
    CLOSE
  </button>
</div>
